import { useQuery } from "react-query"
import { filterFetch, normalFetch } from "../../../fetch-api/get"
import { useMainContext } from "../../../../contexts/main"
import { makeQueryFilters } from "../../../../utils/query-maker"

export const swapKeys = {
    getAllSwapsList: 'getAllSwapsList',
    setSwapSettings: 'setSwapSettings'
}

export const useGetAllSwaps = (filters, pagination, extra, csv) => {

    const { lang } = useMainContext()
    const newFilters = { ...extra, ...filters }
    const params = { ...makeQueryFilters(newFilters, lang), ...pagination }
    if (csv) {
        params.export = 'csv'
    }

    return useQuery(
        swapKeys.getAllSwapsList, () => filterFetch(params, 'swaps/admin'),
        {
            cacheTime: 0
        }
    )
}

